<template>
  <component
    :is="checkbox"
    @click="$emit('toggle')"
    class="dwp-w-5 dwp-h-5 dwp-cursor-pointer"
    :class="checked ? 'dwp-text-green-700' : 'dwp-text-gray-500'"
    style="fill:none"
    role="checkbox"
    stroke-width="2"
    fill="none"
    aria-checked="false"
  />
</template>

<script>
import { CircleIcon, CheckCircleIcon } from "vue-feather-icons";

export default {
  components: {
    CheckCircleIcon,
    CircleIcon
  },
  props: {
    checked: false
  },
  computed: {
    checkbox() {
      return this.checked ? CheckCircleIcon : CircleIcon;
    }
  }
};
</script>